export default "__VITE_ASSET__5def574e__"